import { render, staticRenderFns } from "./CommonPageTable.vue?vue&type=template&id=f28e10b4"
import script from "./CommonPageTable.vue?vue&type=script&lang=js"
export * from "./CommonPageTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports